import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import LayoutReducer from "./Reducers/Layout/LayoutReducer";
import ProductReducer from "./Reducers/ECommerce/ProductReducer";
import FilterReducer from "./Reducers/ECommerce/FilterReducer";
import TodoReducer from "./Reducers/TodoReducer";
import SearchResultReducer from "./Reducers/SearchResultReducer";
import ContactReducer from "./Reducers/ContactReducer";
import TasksReducer from "./Reducers/TasksReducer";
import UsersReducer from "./Reducers/UsersReducer";
import BookmarkReducer from "./Reducers/BookmarkReducer";
import EmailReducer from "./Reducers/LetterBoxReducer";
import ChatReducer from "./Reducers/ChatReducer";
import WholsalerReducer from "./Reducers/wholesaler";
import BrandReducer from "./Reducers/brands";
import RetailerReducer from "./Reducers/retailers";
import ProjectReducer from "./Reducers/ProjectReducer";
import JobSearchReducer from "./Reducers/JobSearchReducer";
import VerificationsReducer from "./Reducers/verifications";
import QueuesReducer from "./Reducers/queues";
import ThemeCustomizerReducer from "./Reducers/Layout/ThemeCustomizerReducer";
import UserManagementReducer from "./Reducers/userManagement";
import OrganizationManagementReducer from "./Reducers/organizationManagement";
import AnalyticsReducer from "./Reducers/analytics";
import AuthReducer from "./Reducers/auth";
import AiKnowledgeBaseReducer from "./Reducers/aiKnowledgeBase";
import MatchesReducer from "./Reducers/matches";
import BrandRequestsReducer from "./Reducers/brandRequests";
import WebsiteLeadsReducer from "./Reducers/websiteLeads";

// Persist config - only persist auth slice
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist auth slice
};

const rootReducer = combineReducers({
  auth: AuthReducer,
  layout: LayoutReducer,
  product: ProductReducer,
  filter: FilterReducer,
  todos: TodoReducer,
  searchResult: SearchResultReducer,
  brands: BrandReducer,
  retailers: RetailerReducer,
  contact: ContactReducer,
  tasks: TasksReducer,
  wholesaler: WholsalerReducer,
  email: EmailReducer,
  chat: ChatReducer,
  project: ProjectReducer,
  jobSearch: JobSearchReducer,
  analytics: AnalyticsReducer,
  userCards: UsersReducer,
  bookmark: BookmarkReducer,
  verifications: VerificationsReducer,
  queues: QueuesReducer,
  themeCustomizer: ThemeCustomizerReducer,
  userManagement: UserManagementReducer,
  organizationManagement: OrganizationManagementReducer,
  aiKnowledgeBase: AiKnowledgeBaseReducer,
  matches: MatchesReducer,
  brandRequests: BrandRequestsReducer,
  websiteLeads: WebsiteLeadsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
